import React from 'react'
import {MdKeyboardArrowLeft} from 'react-icons/md'
import Link from 'next/link'
import {useTranslation} from 'next-i18next'

import styles from './styles.module.css'

export default function GoBack({category}) {
  const {t} = useTranslation('generic')
  return (
    (<Link
      href={category.parent ? `/pedir/category/${category.parent._id}` : `/pedir`}
      prefetch={false}
      scroll={false}
      className={styles.forceColor}>

      <span className={styles.textWithIcon}>
        <MdKeyboardArrowLeft />
        <span className={styles.spaceLeft}>{t('fields.goBack')}</span>
      </span>

    </Link>)
  );
}
